import { c as _c } from "react/compiler-runtime";
import ViverseButton from '@/components/ViverseButton';
import { Link } from '@/i18n/navigation';
import { useTranslations } from 'next-intl';
export default function EmptyFollowingCard() {
  const $ = _c(11);
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t("profile.empty-following-card.description");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <p className="body text-center text-sm md:text-base">{t0}</p>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("profile.empty-following-card.button");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <Link href="/#explore-viverse"><ViverseButton variant="icon3" className="group text-vive-primary-20 bg-vive-ghost-white hover:bg-vive-popup-hover font-medium">{t2}</ViverseButton></Link>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <div className="bg-secondary-normal flex h-[269px] w-full flex-col items-center justify-center gap-5 rounded-2xl">{t1}{t3}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}